import { Component, effect } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { HelperService } from './core/services/helper.service';
import { AuthService } from './core/services/auth.service';
import { IdleTimeoutService } from './core/services/idle-timeout.service';
import { LoadingSpinnerComponent } from './loading-spinner.component';
import { ProgressSpinnerComponent } from './shared/components/progress-spinner/progress-spinner.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingSpinnerComponent, ProgressSpinnerComponent],
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'ArturPro';

  constructor(
    private msalService: MsalService,
    private helperService: HelperService,
    private authService: AuthService,
    private idleTimeoutService: IdleTimeoutService
  ) {
    // Watch the inactivity window only while somebody is signed in.
    effect(() => {
      if (this.authService.isLoggedIn()) {
        this.idleTimeoutService.start();
      } else {
        this.idleTimeoutService.stop();
      }
    });
  }

  ngOnInit() {
    const urlParams = new URLSearchParams(window.location.search);
    const redirect = urlParams.get('redirect');
    if (redirect) {
      //this.router.navigate([redirect]);
      localStorage.setItem('redirect', redirect);
    }
  }
}
